(() => {
  const root = document.querySelector('[data-article-fortune-wheel]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const launcher = root.querySelector('[data-wheel-launcher]');
  const sheet = root.querySelector('.article-fortune-wheel__sheet');
  const closeButtons = root.querySelectorAll('[data-wheel-close]');
  const spinButton = root.querySelector('[data-wheel-spin]');
  const wheel = root.querySelector('[data-wheel-disc]');
  const primaryButton = root.querySelector('[data-wheel-primary]');
  const appLink = root.querySelector('[data-wheel-app]');
  const result = root.querySelector('[data-wheel-result]');
  const resultTitle = root.querySelector('[data-wheel-result-title]');
  const resultCopy = root.querySelector('[data-wheel-result-copy]');
  const offerKicker = root.querySelector('[data-wheel-kicker]');
  const offerTitle = root.querySelector('[data-wheel-title]');
  const offerCopy = root.querySelector('[data-wheel-copy]');

  const articleId = root.dataset.articleId || 'unknown';
  const articleHandle = root.dataset.articleHandle || '';
  const articleTitle = root.dataset.articleTitle || document.title;
  const productId = root.dataset.productId || '';
  const productHandle = root.dataset.productHandle || '';
  const productTitle = root.dataset.productTitle || '';
  const productUrl = root.dataset.productUrl || '';
  const discountCode = root.dataset.discountCode || 'MEMEVIBE10';
  const shippingDiscountCode = root.dataset.shippingDiscountCode || 'FREESHIPW';
  const appStoreUrl = root.dataset.appStoreUrl || appLink?.href || '';
  const ga4MeasurementId = root.dataset.ga4MeasurementId || '';
  const storageKey = `wahup_fortune_wheel_${articleId}`;
  const sessionKey = `wahup_wheel_session_${articleId}`;
  const autoOpenKey = `wahup_fortune_wheel_auto_${articleId}`;
  let autoOpenTimer = null;

  const rewards = [
    {
      id: 'tee10',
      label: '10% OFF tee',
      title: 'You unlocked 10% off',
      copy: `${discountCode} will be applied through Shopify's discount link when you view the tee.`,
      action: 'pod',
      discount: true,
      discountCode,
      weight: 35,
      segment: 0
    },
    {
      id: 'ship',
      label: 'Free shipping',
      title: 'Free shipping unlocked',
      copy: `${shippingDiscountCode} will be applied through Shopify's discount link when you view the tee.`,
      action: 'pod',
      discount: true,
      discountCode: shippingDiscountCode,
      weight: 20,
      segment: 1
    },
    {
      id: 'jcalit',
      label: 'JCALIT handwriting',
      title: 'Try handwriting chat',
      copy: 'Open JCALIT and chat in your own handwriting.',
      action: 'app',
      discount: false,
      weight: 15,
      segment: 2
    },
    {
      id: 'tee15',
      label: '10% OFF today',
      title: 'Lucky 10% tee reward',
      copy: `${discountCode} will be applied through Shopify's discount link when you view the tee.`,
      action: 'pod',
      discount: true,
      discountCode,
      weight: 8,
      segment: 3
    },
    {
      id: 'mystery',
      label: 'Mystery tee pick',
      title: 'Mystery meme tee pick',
      copy: 'Let the product picker choose the tee tied to this meme.',
      action: 'pod',
      discount: false,
      weight: 7,
      segment: 4
    },
    {
      id: 'tee8',
      label: '10% OFF',
      title: 'Reader 10% tee reward',
      copy: `${discountCode} will be applied through Shopify's discount link when you view the tee.`,
      action: 'pod',
      discount: true,
      discountCode,
      weight: 10,
      segment: 5
    },
    {
      id: 'view',
      label: 'Tee pick',
      title: 'Your tee pick is ready',
      copy: 'Open the meme tee matched to this article.',
      action: 'pod',
      discount: false,
      weight: 10,
      segment: 6
    },
    {
      id: 'bonus',
      label: 'Bonus',
      title: 'Bonus reader reward',
      copy: 'Choose the tee reward or try JCALIT handwriting chat.',
      action: 'pod',
      discount: false,
      weight: 10,
      segment: 7
    }
  ];

  const getSessionId = () => {
    try {
      let sessionId = sessionStorage.getItem(sessionKey);
      if (!sessionId) {
        sessionId = typeof crypto.randomUUID === 'function'
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        sessionStorage.setItem(sessionKey, sessionId);
      }
      return sessionId;
    } catch (error) {
      return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
  };

  const wheelSessionId = getSessionId();

  const isVisible = (element) => {
    if (!element) return false;
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity || 1) > 0 &&
      rect.width > 0 &&
      rect.height > 0
    );
  };

  const hasVisibleCookieConsent = () => {
    const banner = document.querySelector(
      '#shopify-pc__banner, .shopify-pc__banner__dialog, [data-testid*="cookie" i], [aria-label*="cookie consent" i]'
    );
    return isVisible(banner);
  };

  const syncCookieConsent = () => {
    root.classList.toggle('is-cookie-consent-visible', hasVisibleCookieConsent());
  };

  const hideArticleChrome = () => {
    document.documentElement.classList.remove('has-navbar');
    document.querySelectorAll('.bottom-navbar, #ShopifyChat, [id^="ShopifyChat"], [id*="shopify-chat"], inbox-online-store-chat, iframe[src*="shopifychat"], iframe[src*="shopify.com/inbox"]').forEach((element) => {
      element.hidden = true;
      element.style.setProperty('display', 'none', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
    });
  };

  const track = (event, details = {}) => {
    const parameters = {
      article_id: String(articleId),
      article_handle: articleHandle,
      article_title: articleTitle,
      product_id: String(productId),
      product_handle: productHandle,
      product_title: productTitle,
      offer_type: 'wheel',
      offer_session_id: wheelSessionId,
      ...details
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      ga4_direct_sent: true,
      ...parameters
    });
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('event', event, {
      ...parameters,
      send_to: ga4MeasurementId
    });
  };

  const readSavedReward = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      return rewards.find((reward) => reward.id === saved?.id) || null;
    } catch (error) {
      return null;
    }
  };

  const saveReward = (reward) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify({
        id: reward.id,
        won_at: Date.now()
      }));
    } catch (error) {
      // Wheel still works without localStorage.
    }
  };

  const pickReward = () => {
    const total = rewards.reduce((sum, reward) => sum + reward.weight, 0);
    let cursor = Math.random() * total;
    return rewards.find((reward) => {
      cursor -= reward.weight;
      return cursor <= 0;
    }) || rewards[0];
  };

  const discountUrl = (code = discountCode) => `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(productUrl)}`;

  const showReward = (reward, isSaved = false) => {
    result.hidden = false;
    resultTitle.textContent = reward.title;
    resultCopy.textContent = reward.copy;
    offerKicker.textContent = isSaved ? 'Saved reward' : 'You won';
    offerTitle.textContent = reward.title;
    offerCopy.textContent = reward.copy;
    primaryButton.disabled = false;
    primaryButton.textContent = reward.action === 'app' ? 'Open JCALIT' : 'View meme tee';
    root.dataset.rewardAction = reward.action;
    root.dataset.rewardId = reward.id;
    root.dataset.rewardDiscount = reward.discount ? 'true' : 'false';
    root.dataset.rewardDiscountCode = reward.discountCode || discountCode;
  };

  const openWheel = (source = 'launcher') => {
    root.hidden = false;
    root.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    sheet.setAttribute('aria-hidden', 'false');
    sheet.focus({ preventScroll: true });
    track('wheel_view', { open_source: source });
    const savedReward = readSavedReward();
    if (savedReward && !root.dataset.rewardId) {
      spinButton.disabled = true;
      spinButton.textContent = 'Won';
      showReward(savedReward, true);
    }
  };

  const closeWheel = () => {
    root.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
    sheet.setAttribute('aria-hidden', 'true');
    track('wheel_close');
  };

  const spin = () => {
    if (spinButton.disabled || root.classList.contains('is-spinning')) return;
    const reward = readSavedReward() || pickReward();
    saveReward(reward);
    spinButton.disabled = true;
    root.classList.add('is-spinning');
    result.hidden = true;
    primaryButton.disabled = true;
    primaryButton.textContent = 'Spinning...';
    track('wheel_spin');

    const segmentCenter = reward.segment * 45 + 22.5;
    const finalRotation = 1440 + (360 - segmentCenter);
    wheel.style.setProperty('--wheel-rotation', `${finalRotation}deg`);

    window.setTimeout(() => {
      root.classList.remove('is-spinning');
      spinButton.textContent = 'Won';
      showReward(reward);
      track('wheel_win', {
        reward_id: reward.id,
        reward_label: reward.label,
        reward_action: reward.action
      });
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 50 : 3700);
  };

  const autoOpenAndSpin = () => {
    if (hasVisibleCookieConsent()) {
      autoOpenTimer = window.setTimeout(autoOpenAndSpin, 700);
      return;
    }

    try {
      if (sessionStorage.getItem(autoOpenKey) === 'true') return;
      sessionStorage.setItem(autoOpenKey, 'true');
    } catch (error) {
      // Auto open once per page even when sessionStorage is unavailable.
    }

    openWheel('auto');
    if (!readSavedReward()) {
      window.setTimeout(spin, 450);
    }
  };

  const openProductOffer = () => {
    const event = new CustomEvent('article-product-offer:open', {
      bubbles: true,
      cancelable: true,
      detail: { source: 'fortune-wheel' }
    });
    const needsFallback = document.dispatchEvent(event);
    const launcherButton = document.querySelector('[data-offer-reopen]');
    if (needsFallback && launcherButton) launcherButton.click();
    if (!launcherButton && productUrl) {
      window.location.href = root.dataset.rewardDiscount === 'true' ? discountUrl(root.dataset.rewardDiscountCode || discountCode) : productUrl;
    }
    track('wheel_cta_pod', {
      reward_id: root.dataset.rewardId || '',
      discount_applied: root.dataset.rewardDiscount === 'true',
      discount_code: root.dataset.rewardDiscountCode || ''
    });
  };

  launcher.addEventListener('click', () => openWheel('launcher'));
  closeButtons.forEach((button) => button.addEventListener('click', closeWheel));
  spinButton.addEventListener('click', spin);
  primaryButton.addEventListener('click', () => {
    if (root.dataset.rewardAction === 'app') {
      track('wheel_cta_app', { reward_id: root.dataset.rewardId || '' });
      window.location.href = appStoreUrl;
      return;
    }
    openProductOffer();
  });
  appLink.addEventListener('click', () => {
    track('wheel_cta_app', { reward_id: root.dataset.rewardId || 'secondary' });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains('is-open')) closeWheel();
  });

  root.hidden = false;
  hideArticleChrome();
  syncCookieConsent();
  new MutationObserver(hideArticleChrome).observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['class', 'style', 'hidden']
  });
  setInterval(hideArticleChrome, 750);
  new MutationObserver(syncCookieConsent).observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true
  });
  window.setTimeout(() => {
    if (!root.classList.contains('is-open')) root.classList.add('is-ready');
  }, 6500);
  autoOpenTimer = window.setTimeout(autoOpenAndSpin, 3000);
})();
